// extracted by mini-css-extract-plugin
export var BlogArticle = "BlogArticle-module--BlogArticle---bAgH";
export var BlogArticle__content = "BlogArticle-module--BlogArticle__content--2d1Iz";
export var BlogArticle__image = "BlogArticle-module--BlogArticle__image--1se9G";
export var BlogArticle__header = "BlogArticle-module--BlogArticle__header--3BkAX";
export var BlogArticle__date = "BlogArticle-module--BlogArticle__date--2Cmj7";